(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iyanu-product-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('iyanu-refined-carousel')) {
 class IyanuOriginalCarousel extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();this.resize?.disconnect();this.abort=new AbortController();
   this.root=this.querySelector('.pcarousel');if(!this.root)return;
   // Marks the instance ready so a legacy asset loaded elsewhere cannot bind it twice.
   this.root.dataset.pcarouselReady='true';
   this.slides=[...this.querySelectorAll('[data-pcarousel-slide]')];
   this.dots=[...this.querySelectorAll('[data-pcarousel-dot]')];this.index=0;
   const on=(target,event,handler)=>target.addEventListener(event,handler,{signal:this.abort.signal});
   on(this,'click',e=>{
    if(e.target.closest('[data-pcarousel-prev]'))this.show(this.index-1);
    if(e.target.closest('[data-pcarousel-next]'))this.show(this.index+1);
    const dot=e.target.closest('[data-pcarousel-dot]');if(dot)this.show(Number(dot.dataset.pcarouselDot));
   });
   on(this,'keydown',e=>{
    if(!e.target.closest('button'))return;
    if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1));}
   });
   on(this,'pointerdown',e=>{if(e.pointerType==='touch' && !e.target.closest('a,button'))this.touch={x:e.clientX,y:e.clientY};});
   on(this,'pointerup',e=>{if(!this.touch)return;const dx=e.clientX-this.touch.x,dy=e.clientY-this.touch.y;this.touch=null;if(Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy))this.show(this.index+(dx<0?1:-1));});
   on(this,'pointercancel',()=>{this.touch=null;});
   on(document,'shopify:block:select',e=>{const index=this.slides.findIndex(s=>s.dataset.blockId===e.detail?.blockId);if(index>=0)this.show(index);});
   this.show(0, false);
   this.resize=new ResizeObserver(()=>this.positionArrows());
   this.resize.observe(this.root);
   this.slides.forEach(slide=>this.resize.observe(slide));
  }
  positionArrows(){
   const slide=this.slides[this.index];if(!slide)return;
   const root=this.root.getBoundingClientRect(), stage=this.querySelector('.pcarousel__stage').getBoundingClientRect();
   let y=stage.top-root.top+stage.height/2;
   if(matchMedia('(max-width:1024px)').matches){
    const space=parseFloat(getComputedStyle(slide,'::before').height)||220;
    const pills=slide.querySelector('.pcarousel__pills');
    const button=slide.querySelector('.pcarousel__btn');
    const bottom=pills?.getBoundingClientRect().top ?? button?.getBoundingClientRect().top ?? (slide.getBoundingClientRect().bottom-parseFloat(getComputedStyle(slide).paddingBottom));
    y=bottom-root.top-space/2;
   }
   this.root.style.setProperty('--nav-y',y+'px');
   this.root.style.setProperty('--nav-left',(stage.left-root.left+10)+'px');
   this.root.style.setProperty('--nav-right',(root.right-stage.right+10)+'px');
  }
  show(index, animate = true){
   if(!this.slides.length)return;
   const next=(index+this.slides.length)%this.slides.length;
   const changed=next!==this.index;
   this.index=next;
   this.animations?.forEach(a=>a.cancel());this.animations=[];
   this.slides.forEach((slide,i)=>{const active=i===this.index;slide.classList.toggle('is-active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));});
   this.dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===this.index);dot.setAttribute('aria-current',String(i===this.index));});
   this.positionArrows();
   if (animate && changed) {
    this.querySelector('.pcarousel__status').textContent='Producto '+(this.index+1)+' de '+this.slides.length;
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
     const slide=this.slides[this.index];
     this.animations.push(slide.animate([{opacity:.25},{opacity:1}],{duration:420,easing:'cubic-bezier(.22,1,.36,1)'}));
     const image=Array.from(slide.querySelectorAll('img')).find(img=>img.offsetWidth>0);
     if(image)this.animations.push(image.animate([{transform:'scale(1.025)'},{transform:'scale(1)'}],{duration:650,easing:'cubic-bezier(.22,1,.36,1)'}));
    }
   }
  }
  disconnectedCallback(){this.resize?.disconnect();this.abort?.abort();this.animations?.forEach(a=>a.cancel());}
 }
 customElements.define('iyanu-refined-carousel',IyanuOriginalCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quotes"] && !Shopify.designMode) return;
  try {
    
(function($) {
    swipr = () => {
        if($('.quotes-slider').length) {          
            $(".quotes-slider").each(function(i) {
                let slides_per_view = $(this).attr('slidesperview');
                let pause_on_hover = $(this).attr('pauseonhover') ? true : false;
                let slide_delay = $(this).attr('slidedelay');
				let id = $(this).attr('slider-id');
                let swiper = new Swiper($(this)[0], {
                    loop: true,
                    slidesPerView: slides_per_view,
                    spaceBetween: 20,
                    autoplay: {
                        delay: slide_delay,
                    },
                  pagination: {
                    el: '#pagination-' + id + '-btn',
                    clickable: true
                  },
                  navigation: {
                    nextEl: '#next-' + id + '-btn',
                    prevEl: '#prev-' + id + '-btn'
                  },
              // Responsive breakpoints
                breakpoints: {
                  // when window width is >= 320px
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20
                  },
                  // when window width is >= 480px
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 30
                  },
                  // when window width is >= 640px
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 40
                  }
                }
                });
            });
        }
    };
     
    document.addEventListener("DOMContentLoaded", () => { swipr() }); 
})(jQuery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routinediaynoche_clau"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('iyanu-routine')) {
 class IyanuRoutine extends HTMLElement {
  connectedCallback() {
   this.cleanup();
   this.timers = [];
   this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
   this.onMotion = () => { this.cleanup(); this.connectedCallback(); };
   this.motion.addEventListener('change', this.onMotion);
   if (this.motion.matches) return;
   const start = (selector, delay) => {
    const images = Array.from(this.querySelectorAll(selector + ' img'));
    if (images.length < 2) return;
    let index = Math.max(0, images.findIndex(img => img.classList.contains('is-active')));
    this.timers.push(setTimeout(() => {
     this.timers.push(setInterval(() => {
      images[index].classList.remove('is-active');
      index = (index + 1) % images.length;
      images[index].classList.add('is-active');
     }, 2800));
    }, delay));
   };
   start('.routine__product-stage--day', 0);
   start('.routine__product-stage--night', 1400);
   start('.routine__desktop-stage--day', 0);
   start('.routine__desktop-stage--night', 1400);
   if ('IntersectionObserver' in window) {
    this.classList.add('is-ready');
    this.observer = new IntersectionObserver(entries => {
     entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.style.transitionDelay = (entry.target.dataset.iyanuRevealDelay || 0) + 'ms';
      entry.target.classList.add('is-visible');
      this.observer.unobserve(entry.target);
     });
    }, {threshold: 0.2, rootMargin: '0px 0px -60px 0px'});
    this.querySelectorAll('[data-iyanu-reveal]').forEach(el => this.observer.observe(el));
   }
  }
  cleanup() {
   (this.timers || []).forEach(timer => { clearTimeout(timer); clearInterval(timer); });
   this.observer?.disconnect();
   if (this.motion && this.onMotion) this.motion.removeEventListener('change', this.onMotion);
   this.classList.remove('is-ready');
  }
  disconnectedCallback() { this.cleanup(); }
 }
 customElements.define('iyanu-routine', IyanuRoutine);
}

  } catch(e) { console.error(e); }
})();
})();
